import { Card, Grid } from '@mui/material';
import React from 'react';
import CardHeader from './CardHeader';
import CardContent from './CardContent';
import { HtmlTooltip } from 'components/tooltips/HtmlTootip';
import InfoIcon from '@mui/icons-material/Info';

function CardWrapper({
  children, title, tooltipMessage, customInfo,
}) {
  return (
    <Card
      sx={{
        padding: '48px',
        border: '1px solid #BFC9C2',
        borderRadius: '16px',
        background: '#F8FAF6',
        boxShadow: 'none',
      }}
    >
      <CardHeader
        title={title}
        tooltipInfo={
          tooltipMessage && (
            <HtmlTooltip
              title={tooltipMessage}
              placement="right"
              arrow
              interactive
            >
              <InfoIcon
                sx={{ width: 24, height: 24 }}
                color="primary"
                fontSize="inherit"
              />
            </HtmlTooltip>
          )
        }
        customInfo={customInfo}
      />
      <CardContent>
        <Grid container spacing={2}>
          {children}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default CardWrapper;
